if (!customElements.get('sticky-product-atc')) {
  customElements.define(
    'sticky-product-atc',
    class StickyProductAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.mainButton = document.getElementById(this.dataset.mainButtonId);
        this.form = this.querySelector('form');
        this.variantInput = this.form?.querySelector('[name="id"]');
        this.variantSelect = this.querySelector('[data-sticky-variant-select]');
        this.quantityInput = this.querySelector('[data-sticky-quantity-input]');
        this.minusButton = this.querySelector('[data-sticky-quantity-minus]');
        this.plusButton = this.querySelector('[data-sticky-quantity-plus]');
        this.submitButton = this.querySelector('[type="submit"]');

        if (!this.mainButton || !this.form || !this.variantInput || !this.quantityInput) return;

        this.onScroll = this.requestVisibilityUpdate.bind(this);
        this.onResize = this.requestVisibilityUpdate.bind(this);
        this.onMainVariantChange = this.syncVariantFromMainForm.bind(this);
        this.onMainQuantityChange = this.syncQuantityFromMainForm.bind(this);

        this.variantSelect?.addEventListener('change', () => this.syncVariantFromStickySelect());
        this.minusButton?.addEventListener('click', () => this.stepQuantity(-1));
        this.plusButton?.addEventListener('click', () => this.stepQuantity(1));
        this.quantityInput.addEventListener('change', () => this.normalizeQuantity());

        const mainForm = document.getElementById(`product-form-${this.sectionId}`);
        mainForm?.querySelector('[name="id"]')?.addEventListener('change', this.onMainVariantChange);

        const mainQuantity = this.getMainQuantityInput();
        mainQuantity?.addEventListener('change', this.onMainQuantityChange);
        mainQuantity?.addEventListener('input', this.onMainQuantityChange);

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);

        this.syncVariantFromMainForm();
        this.syncQuantityFromMainForm();
        this.updateVisibility();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        document.body.classList.remove('sticky-product-atc-visible');
        document.documentElement.style.removeProperty('--sticky-product-atc-height');

        const mainForm = document.getElementById(`product-form-${this.sectionId}`);
        mainForm?.querySelector('[name="id"]')?.removeEventListener('change', this.onMainVariantChange);

        const mainQuantity = this.getMainQuantityInput();
        mainQuantity?.removeEventListener('change', this.onMainQuantityChange);
        mainQuantity?.removeEventListener('input', this.onMainQuantityChange);
      }

      requestVisibilityUpdate() {
        if (this.visibilityFrame) return;
        this.visibilityFrame = requestAnimationFrame(() => {
          this.visibilityFrame = null;
          this.updateVisibility();
        });
      }

      updateVisibility() {
        const rect = this.mainButton.getBoundingClientRect();
        const isVisible = rect.bottom < 0;

        this.classList.toggle('is-visible', isVisible);
        document.body.classList.toggle('sticky-product-atc-visible', isVisible);
        this.updateFooterOffset(isVisible);
      }

      updateFooterOffset(isVisible) {
        if (!isVisible) {
          document.documentElement.style.removeProperty('--sticky-product-atc-height');
          return;
        }

        const panelHeight = Math.ceil(this.getBoundingClientRect().height);
        document.documentElement.style.setProperty('--sticky-product-atc-height', `${panelHeight}px`);
      }

      syncVariantFromMainForm() {
        const mainVariantInput = document.querySelector(`#product-form-${this.sectionId} [name="id"]`);
        if (!mainVariantInput?.value) return;

        this.variantInput.value = mainVariantInput.value;

        if (this.variantSelect) {
          this.variantSelect.value = mainVariantInput.value;
        }

        this.updateSubmitState();
      }

      syncVariantFromStickySelect() {
        if (!this.variantSelect?.value) return;
        this.variantInput.value = this.variantSelect.value;
        this.updateSubmitState();
      }

      syncQuantityFromMainForm() {
        const mainQuantity = this.getMainQuantityInput();
        if (!mainQuantity?.value) return;
        this.quantityInput.value = mainQuantity.value;
        this.normalizeQuantity();
      }

      getMainQuantityInput() {
        return document.querySelector(`#product-form-${this.sectionId} [name="quantity"]`) ||
          document.getElementById(`Quantity-${this.sectionId}`);
      }

      stepQuantity(step) {
        const current = Number(this.quantityInput.value || 1);
        this.quantityInput.value = String(current + step);
        this.normalizeQuantity();
      }

      normalizeQuantity() {
        const min = Number(this.quantityInput.getAttribute('min') || 1);
        const max = this.quantityInput.getAttribute('max') ? Number(this.quantityInput.getAttribute('max')) : null;
        const next = Math.max(min, Math.floor(Number(this.quantityInput.value || min)));

        this.quantityInput.value = String(max ? Math.min(next, max) : next);
      }

      updateSubmitState() {
        if (!this.submitButton) return;

        const selectedOption = this.variantSelect?.selectedOptions?.[0];
        const disabled = Boolean(selectedOption?.disabled) || !this.variantInput.value;
        this.submitButton.toggleAttribute('disabled', disabled);
        this.submitButton.querySelector('span').textContent = disabled ? window.variantStrings.soldOut : window.variantStrings.addToCart;
      }
    }
  );
}
